import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS} from '@angular/common/http';

import {BehaviorSubject, Observable, of, throwError} from 'rxjs';
import {catchError, filter, switchMap} from 'rxjs/operators';

import {IdamService} from './idam.service';
import {Router} from '@angular/router';
import {Store} from "@ngrx/store";
import {AppState} from "../store/app.state";
import {authActions} from "../store/auth/action-types";

const TOKEN_HEADER_KEY = 'Authorization';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {

  // private isRefreshing = false;
  private isRefreshing$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private idamService: IdamService
    , private router: Router,
    private _store: Store<AppState>
  ) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if (req.urlWithParams.startsWith('/assets') || req.url.endsWith('json')){
      return next.handle(req);
    }
    let authReq = req.clone({withCredentials: true});
    const token = this.idamService.tokenValue;
    if (token != null) {
      authReq = this.addTokenHeader(req, token);
    }
    return next.handle(authReq)
      .pipe(
        catchError(error => {
          console.error('an error intercepted at url ', req.urlWithParams);
          if (error.status === 413) {
            return throwError(error);
          }
          if (error.status === 400 && error.error.data?.errorIndex == 1) {
            return;
          }
          if (error.status === 400 && (error?.error?.message || error?.message)) {
            return throwError(error);
          }
          if (error instanceof HttpErrorResponse && this.isErrorTypeJwtExpired(error)) {

            return this.handle401Error(authReq, next);
          }
          if (this.isRefreshTokenExpired(error)) {
            debugger;
            console.error('Refresh token expired...');
            localStorage.clear();
            void this.router.navigateByUrl('/login');
            return of(null);
          }
          return throwError(error);
        }));
  }

  // intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<Object>> {
  //   if (request.url.indexOf('googleapis.com') > -1){
  //     return next.handle(request);
  //   }
  //   const checkToken = localStorage.getItem(Constants.TOKEN);
  //   request = (checkToken && checkToken != null) ? request.clone({

  //     setHeaders: {
  //       Authorization: `Bearer ${localStorage.getItem('token')}`
  //     },
  //     // setParams: {
  //     //   lang: this.translate.currentLang
  //     // }
  //   }) : request.clone({
  //     // setParams: {
  //     //   lang: this.translate.currentLang
  //     // }
  //   });
  //   // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  //   return next.handle(request).pipe(
  //     catchError((err: any) => {
  //       console.log('Im the APP MODULE interceptor working good!');
  //       if (err instanceof HttpErrorResponse) {
  //         console.log('APP MODULE interceptor Making LOGOUT, ERROR CODE:', err.status);
  //         console.log('REQUEST FAILED:', request.method, request.url);

  //         if (this.isErrorTypeJwtExpired(err)) {
  //           console.error('JWT EXPIRED');
  //           this.idamService
  //             .refreshToken({
  //               token: localStorage.getItem('token') ?? '',
  //               refreshToken: localStorage.getItem(Constants.REFRESH_TOKEN) ?? ''
  //             }).pipe(
  //               catchError((err: any) => {
  //                 throw new Error();
  //               })
  //             )
  //             .subscribe(
  //               (response) => {
  //                 localStorage.setItem(Constants.TOKEN, response.token);
  //                 localStorage.setItem(Constants.REFRESH_TOKEN, response.refreshToken);
  //               },
  //               (error) => {
  //                 // void this.idamService.logout();

  //                 this.idamService.logout();
  //               }
  //             );
  //             throw err;
  //         }

  //         if(err.status === 413) {
  //           return throwError(err);
  //         }


  //          if (
  //            err.error?.code !== '' &&
  //            err.error.message !== 'Authorizer: jwt expired'
  //          ) {
  //            throw err;
  //          }
  //         if (err.status === 403 || err.status === 401 || err.status === 200) {

  //           console.log(localStorage.getItem(Constants.REFRESH_TOKEN));
  //           if (localStorage.getItem(Constants.REFRESH_TOKEN)) {


  //           } else {

  //             // void this.idamService.logout();
  //             localStorage.clear();
  //           }
  //         } else if (err.status === 500){
  //           // void this.idamService.logout();
  //         }
  //         // if(localStorage.getItem('token'))
  //         // this.idamService.logout()
  //         // localStorage.clear()
  //       }

  //       return of(err);
  //     }));
  // }

  private isErrorTypeJwtExpired(error: HttpErrorResponse): boolean {
    return (error.error.message === 'Authorizer: jwt expired' && error.status === 403);
  }

  private isRefreshTokenExpired(error: HttpErrorResponse): boolean {
    return error.error.code === 'refresh_token_expired' && error.status === 401;
  }

  private addTokenHeader(request: HttpRequest<any>, token: string): any {

    return request.clone({headers: request.headers.set(TOKEN_HEADER_KEY, `Bearer ${token}`)});
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler): any {
    if (!this.isRefreshing$.value) {
      this.isRefreshing$.next(true);

      const token = this.idamService.tokenValue;
      const refreshToken = this.idamService.refreshTokenValue;
      if (token) {
        return this.idamService.refreshToken({token, refreshToken}).pipe(
          switchMap((newToken:{token: string, refreshToken: string}) => {
            
            this.idamService.setToken(newToken.token, newToken.refreshToken);
            this._store.dispatch(authActions.authenticatingRefreshTokenEnd({token:newToken.token,refreshToken: newToken.refreshToken}));

            this.isRefreshing$.next(false);

            return next.handle(this.addTokenHeader(request, newToken.token));
          }),
          catchError((err) => {
            
            this.idamService.setToken('', '');

            this.idamService.logout();
            this.isRefreshing$.next(false);
            return throwError(err);
          })
        );
      }
    }else{
      return this.isRefreshing$.pipe(
        filter(result => result === false),
        switchMap(result=>{
          if (!result){
            return next.handle(this.addTokenHeader(request, this.idamService.tokenValue));
          }else{
            throw new Error("Token not refreshed");
          }
        })
      );
    }
  }
}

// export const authInterceptorProviders = [
//   {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true}
// ];
